// generated by srcset-codegen
import src from "./trash-8.svg";

const width = 9;
const height = 9;
export default { src, width, height };
